<script>
  function same(set1, set2) {
    if (!set1 || !set2) return false
    if (set1.size !== set2.size) return false

    for (const i of set1) {
      if (!set2.has(i)) return false
    }

    return true
  }

  const queries = {
    tablet: 'screen and (min-width: 768px)',
    laptop: 'screen and (min-width: 1152px)'
  }

  const common = new Set(['tablet'])

  export default {
    name: 'Media',

    props: {
      value: {
        required: true
      }
    },

    // Declared per CMP-15: an undeclared native-named emit runs the parent's handler twice.
    emits: ['input'],

    common,

    data() {
      return {
        sizes: common
      }
    },

    // Previously this rendered one `vue-media` child per query and read
    // `matches` off its ref. That package is Vue 2-only, and the two queries
    // here are fixed, so `matchMedia` directly removes both the dependency and
    // a layer of child components without changing what this emits or renders.
    mounted() {
      this.listeners = Object.entries(queries).map(([key, query]) => {
        const list = window.matchMedia(query)
        const onChange = () => this.process(key, list.matches ? 'add' : 'delete')

        // addEventListener is unsupported on MediaQueryList before Safari 14;
        // addListener is deprecated but universal. Keeping both so this feature
        // does not narrow browser support.
        if (list.addEventListener) {
          list.addEventListener('change', onChange)
        } else {
          list.addListener(onChange)
        }

        return { list, onChange }
      })

      const matched = Object.keys(queries).reduce((acc, key) => {
        if (window.matchMedia(queries[key]).matches) acc.add(key)
        return acc
      }, new Set())

      this.sizes = matched

      if (!same(this.sizes, this.value)) {
        this.emit()
      }
    },

    beforeUnmount() {
      ;(this.listeners || []).forEach(({ list, onChange }) => {
        if (list.removeEventListener) {
          list.removeEventListener('change', onChange)
        } else {
          list.removeListener(onChange)
        }
      })
    },

    methods: {
      process(size, method) {
        const current = new Set([...this.sizes])

        this.sizes[method](size)

        if (!same(current, this.sizes)) {
          this.emit()
        }
      },

      emit() {
        this.$emit('input', new Set([...this.sizes]))
      }
    },

    // Unchanged: an empty div, exactly as before. The old `vue-media` children
    // rendered nothing without a slot, so the DOM output was already just this.
    render(createElement) {
      return createElement('div', {}, [])
    }
  }
</script>
